export default __webpack_public_path__ + "static/media/screens.f7348dfb.webp";